'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagEhAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M28 0H1.01725e-05V20H28V0Z", fill: "white" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M27.9998 13.3333H-0.000152588L1.01725e-05 20H28L27.9998 13.3333Z",
          fill: "#20934F"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M28 0H1.01725e-05V6.66667H28V0Z", fill: "#262626" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M28 6.66667H1.01725e-05L-0.000152588 13.3333H27.9998L28 6.66667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.1804 10.3099L17.6463 10.6906L17.8434 10.065L17.3162 9.67468L17.9721 9.66877L18.1804 9.0468L18.3887 9.66877L19.0446 9.67468L18.5175 10.065L18.7145 10.6906L18.1804 10.3099Z",
          fill: "#E81B42"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M18.2983 11.4486C17.948 11.7906 17.4773 12 16.9597 12C15.8774 12 15 11.0846 15 9.95547C15 8.82632 15.8774 7.91095 16.9597 7.91095C17.4773 7.91095 17.948 8.12033 18.2983 8.46234C18.0568 8.34743 17.7836 8.28268 17.4943 8.28268C16.5104 8.28268 15.7128 9.03162 15.7128 9.95548C15.7128 10.8793 16.5104 11.6283 17.4943 11.6283C17.7836 11.6283 18.0568 11.5635 18.2983 11.4486Z",
          fill: "#E62539"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.01725e-05 0L13.3333 10L1.01725e-05 20V0Z",
          fill: "#E62539"
        }
      )
    ]
  }
);
const VpFlagEhAsset = forwardRef(FlagEhAsset);

export { VpFlagEhAsset as default };
